<template>
  <div class="social-section-component">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 mb-5">
          <div class="cta-text text-center">
            <h2>Follow us online</h2>
            <p>
              Like us on Facebook and follow us on Instagram @DutcheChocolatesPH
              <br />to keep updated with everything Dutché!
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <ul class="list-inline mx-auto d-none d-lg-inline">
          <li class="list-inline-item" v-for="(image, index) in igImages" :key="index"><a :href="image.url" target="_blank"><img :src="image.image" class="insta-img"></a></li>
        </ul>
        <ul class="list-inline mx-auto d-inline d-lg-none">
          <li class="list-inline-item" v-for="(image, index) in igImages" :key="index" :class="index === 3 ? 'd-none' : ''"><a :href="image.url" target="_blank"><img :src="image.image" class="insta-img"></a></li>
        </ul>
      </div>
    </div>
  </div>  
</template>

<script>
export default {
  name: 'Social',
  props: {
    igImages: Array
  }
}
</script>

<style lang="sass" scoped>
.cta-text
  margin-top: 8rem

h2
  font-size: 3em
  font-family: "Might Could"

.social-section-component
  margin-bottom: 10rem

.insta-img 
  height: 300px
  width: 300px
  
@media(min-width: 768px)
  h2
    font-size: 5em

@media(max-width: 767px)
  .social-box
    padding-left: 0
    text-align: center
    margin-bottom: 1rem

  .insta-img
    height: 110px !important
    width: 110px !important

@media(max-width: 992px)
  .insta-img
    height: 200px
    width: 200px
</style>

